/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeContactPermissionsRequestBody
 */
export interface ChangeContactPermissionsRequestBody {
    /**
     * 
     * @type {boolean}
     * @memberof ChangeContactPermissionsRequestBody
     */
    emailAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeContactPermissionsRequestBody
     */
    phoneAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeContactPermissionsRequestBody
     */
    smsAllowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeContactPermissionsRequestBody
     */
    whatsappAllowed: boolean;
}

/**
 * Check if a given object implements the ChangeContactPermissionsRequestBody interface.
 */
export function instanceOfChangeContactPermissionsRequestBody(value: object): value is ChangeContactPermissionsRequestBody {
    if (!('emailAllowed' in value) || value['emailAllowed'] === undefined) return false;
    if (!('phoneAllowed' in value) || value['phoneAllowed'] === undefined) return false;
    if (!('smsAllowed' in value) || value['smsAllowed'] === undefined) return false;
    if (!('whatsappAllowed' in value) || value['whatsappAllowed'] === undefined) return false;
    return true;
}

export function ChangeContactPermissionsRequestBodyFromJSON(json: any): ChangeContactPermissionsRequestBody {
    return ChangeContactPermissionsRequestBodyFromJSONTyped(json, false);
}

export function ChangeContactPermissionsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeContactPermissionsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'emailAllowed': json['emailAllowed'],
        'phoneAllowed': json['phoneAllowed'],
        'smsAllowed': json['smsAllowed'],
        'whatsappAllowed': json['whatsappAllowed'],
    };
}

export function ChangeContactPermissionsRequestBodyToJSON(json: any): ChangeContactPermissionsRequestBody {
    return ChangeContactPermissionsRequestBodyToJSONTyped(json, false);
}

export function ChangeContactPermissionsRequestBodyToJSONTyped(value?: ChangeContactPermissionsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailAllowed': value['emailAllowed'],
        'phoneAllowed': value['phoneAllowed'],
        'smsAllowed': value['smsAllowed'],
        'whatsappAllowed': value['whatsappAllowed'],
    };
}

